import { useState } from 'react';

export const useTableSort = ({
  defaultSortField,
  defaultIsDescending,
} = {}) => {
  const [sortField, setSortField] = useState(defaultSortField);
  const [isSortOrderDescending, setIsSortOrderDescending] =
    useState(defaultIsDescending);

  const setCurrentSorting = (updatedSortField, updatedSortOrder) => {
    setSortField(updatedSortField);
    setIsSortOrderDescending(updatedSortOrder);
  };

  return [sortField, isSortOrderDescending, setCurrentSorting];
};
